export default __webpack_public_path__ + "static/media/oean.d64d18bf.jpg";